import { TimberBuyerSearchPage } from '@features/TimberBuyer/Search/TimberBuyerSearchPage'
import { timberBuyerSearchSchema } from '@services/queryOptions'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/timberbuyer/search')({
  validateSearch: timberBuyerSearchSchema,
  loaderDeps: ({ search }) => search,
  component: TimberBuyerSearchPage,
  staticData: { breadcrumb: 'Tømmerkjøper' },
})
